import { Button, Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

const OverviewTab = ({ service }) => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col
          span={8}
          className="step-0-col-8"
          style={{ minHeight: '40vh' }}
        >
          <div style={{ padding: '16px', color: '#FFFFFF' }}>
            <ReactMarkdown source={service?.releaseInfo ?? ''} />
          </div>
        </Col>
        <Col span={16} className="step-0-col-16">
          <div style={{ padding: '16px', color: '#FFFFFF' }}>
            <ReactMarkdown source={service?.overview ?? ''} />
          </div>
        </Col>
      </Row>
      <div style={{ width: '100%', textAlign: 'end', marginTop: '16px' }}>
        <Button type="primary">
          {t('Đăng ký dùng thử')}
        </Button>
      </div>
    </>
  );
};

export default OverviewTab;
